export const GUIDES_AMOUNT = 5;
export const REVIEWS_AMOUNT = 15;
